interface DiscordIconProps {
  className?: string;
}

const DiscordIcon = ({ className }: DiscordIconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 71 55' fill='currentColor' className={className}>
    <path d='M60.1 4.9A58.5 58.5 0 0045.4.2a.2.2 0 00-.2.1 40.8 40.8 0 00-1.8 3.7 54 54 0 00-16.2 0A37.4 37.4 0 0025.4.3a.2.2 0 00-.2-.1A58.4 58.4 0 0010.5 4.9.2.2 0 0010.4 5C1.5 18.4-.9 31.5.3 44.4v.2a58.7 58.7 0 0017.7 9 .2.2 0 00.3-.1 42 42 0 003.6-5.9.2.2 0 00-.1-.3 38.6 38.6 0 01-5.5-2.6.2.2 0 01 0-.4c.4-.3.7-.6 1.1-.9a.2.2 0 01.2 0c11.6 5.3 24.2 5.3 35.7 0a.2.2 0 01.2 0l1.1.9a.2.2 0 010 .4 36.3 36.3 0 01-5.5 2.6.2.2 0 00-.1.3 47.2 47.2 0 003.6 5.9.2.2 0 00.3.1A58.5 58.5 0 0070.3 44.6v-.2c1.4-14.5-2.4-27.1-10-38.3a.2.2 0 00-.1-.1zM23.7 36.5c-3.3 0-6-3-6-6.8s2.6-6.8 6-6.8 6.1 3.1 6 6.8c0 3.7-2.7 6.8-6 6.8zm22.2 0c-3.3 0-6-3-6-6.8s2.6-6.8 6-6.8 6.1 3.1 6 6.8c0 3.7-2.6 6.8-6 6.8z' />
  </svg>
);

export default DiscordIcon;
